// extracted by mini-css-extract-plugin
export default {"info":"FileUploadHints_info__YkAHP","desc":"FileUploadHints_desc__yovki"};